import { useState } from 'react';

const useInformation = () => {
  const [isInformationDialogOpen, setIsInformationDialogOpen] = useState(false);

  const onInformationClick = () => {
    setIsInformationDialogOpen(true);
  };

  const onInformationDialogClose = () => {
    setIsInformationDialogOpen(false);
  };

  return { isInformationDialogOpen, onInformationClick, onInformationDialogClose };
};

export default useInformation;
